import React, { useState } from "react";
import { useAuth } from "../../../AuthContext";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Typography,
  Card,
  CardContent,
  Box,
  InputAdornment,
} from "@mui/material";
import { AccountCircle, Lock } from "@mui/icons-material";
import API_BASE_URL from "../../../config/api";

const Login = () => {
  const [employeeId, setEmployeeId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  // get current malaysia year
  const getCurrentYear = () => {
    const malaysiaTime = new Date().toLocaleString("en-US", {
      timeZone: "Asia/Kuala_Lumpur",
    });
    return new Date(malaysiaTime).getFullYear();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await login(employeeId, password);

    if (result.success) {
      navigate("/admin/appointment");
    } else {
      setError(result.message);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        position: "relative",
        backgroundImage: `url(${API_BASE_URL}/uploads/headerImg/bodyfriend_outlet.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Semi-transparent overlay */}
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(10, 10, 10, 0.50)", // Darkens the background
          zIndex: 1,
        }}
      ></Box>

      <Card
        sx={{
          width: "100%",
          maxWidth: 400,
          p: 3,
          boxShadow: 3,
          borderRadius: 3,
          position: "relative",
          zIndex: 2, // Ensures card is above overlay
          backgroundColor: "rgba(255, 255, 255, 0.9)", // Makes card slightly transparent
          margin: 2,
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            fontWeight="bold"
            textAlign="center"
            gutterBottom
          >
            Admin Login
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            textAlign="center"
            mb={3}
          >
            Enter your credentials to continue
          </Typography>

          {error && (
            <Typography variant="body2" color="error" textAlign="center" mb={2}>
              {error}
            </Typography>
          )}

          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ display: "flex", flexDirection: "column", gap: 2 }}
          >
            <TextField
              label="Employee ID"
              variant="outlined"
              fullWidth
              value={employeeId}
              onChange={(e) => setEmployeeId(e.target.value)}
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle />
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              label="Password"
              variant="outlined"
              type="password"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock />
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ mt: 2, bgcolor: "primary.main", py: 1.5 }}
            >
              Sign In
            </Button>
          </Box>

          <Typography variant="body2" textAlign="center" mt={2}>
            <Button onClick={() => navigate("/forgot-password")} size="small">
              Forgot Password?
            </Button>
          </Typography>

          <Typography
            variant="body2"
            color="textSecondary"
            textAlign="center"
            mt={3}
          >
            © {getCurrentYear()} Bodyfriend Admin Dashboard
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Login;
